import React, { FC } from 'react'
import { Link, useTranslation } from 'gatsby-plugin-react-i18next'
import Button, { ButtonSizes } from 'src/components/ui/Button'
import IsoBadge from 'src/components/ui/IsoBadge'
import { DesignSystemSearch } from 'src/design-system'
import { getPreviewCopy } from 'src/helpers/preview'
import { IDesktopActionsProps } from './types'

export const DesktopActions: FC<IDesktopActionsProps> = ({
  shouldShowIso = true,
  isDesignSystem = false,
  actionText,
  actionUrl,
  onActionClick,
  actionSlot,
  actionIcon,
  isActionOutline = false,
}) => {
  const { t } = useTranslation('header')

  return (
    <div className="flex items-center gap-6 lg:gap-6 xl:gap-8 shrink-0">
      {shouldShowIso && (
        <>
          <IsoBadge layout="horizontal" align="right" />
          <div className="w-constant-1 h-[62px] lg:h-[48px] xl:h-[62px] bg-outline-base shrink-0" />
        </>
      )}

      {isDesignSystem ? (
        <>
          <DesignSystemSearch />
          <Link to="/contact">
            <Button size={ButtonSizes.large}>
              <span className="flex items-center gap-1.5">
                <svg className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                </svg>
                <span>create</span>
              </span>
            </Button>
          </Link>
        </>
      ) : actionSlot ? (
        actionSlot
      ) : (
        <Link to={actionUrl || '/contact'}>
          <Button size={ButtonSizes.large} isOutline={isActionOutline} onClick={onActionClick}>
            <span className="flex items-center gap-1.5">
              {actionIcon}
              <span>{actionText || getPreviewCopy('header.contactButton', t('contact us'))}</span>
            </span>
          </Button>
        </Link>
      )}
    </div>
  )
}

export default DesktopActions
